import {
  WIRCreateJourneyStepsKeys,
  WIRStageGate2SectionKey,
  WIRStageGate2Sections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { WIR } from 'types/wellGuardian';

export const getWirStageGate2Sections = (wir: WIR | null) =>
  (wir &&
    Object.keys(WIRStageGate2Sections).map(item => ({
      label: WIRStageGate2Sections[item as WIRStageGate2SectionKey],
      value: item,
      phase: WIRCreateJourneyStepsKeys.STAGE_GATE_2,
    }))) ??
  [];
